import { render, staticRenderFns } from "./FrameworkSwitcher2.vue?vue&type=template&id=0b1ea2f1&"
import script from "./FrameworkSwitcher2.vue?vue&type=script&lang=js&"
export * from "./FrameworkSwitcher2.vue?vue&type=script&lang=js&"
import style0 from "./FrameworkSwitcher2.vue?vue&type=style&index=0&id=0b1ea2f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VHover,VIcon,VList,VListItem,VListItemAction,VListItemIcon,VListItemTitle,VMenu})
